// Bloc & Brush — Turnkey Luxury Portfolio & Server Project Database

export const PROJECTS_GROUPS = [
  {
    city: "Dubai",
    areas: [
      {
        area: "JBR",
        coords: "Jumeirah Beach Residence",
        items: [
          {
            id: "beachfront-residence-jbr",
            slug: "beachfront-residence-jbr",
            bhk: "2 BHK",
            title: "Beachfront Residence · JBR",
            subtitle: "Turnkey Holiday Home Fit-Out & Furnishing",
            description:
              "Light-flooded two-bedroom apartment fronting JBR's promenade. Designed for high-yielding short stays with a calm, coastal luxury aesthetic, bespoke joinery, integrated media wall, and turnkey kitchen.",
            image:
              "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "1,450 sq ft",
            turnkeyTimeline: "16 Days",
            completionYear: "2025",
            clientType: "Holiday Home Investor",
            gallery: [
              "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Full Architectural Interior Fit-Out",
              "Custom Oak Joinery & Built-in Wardrobes",
              "Ambient LED Cove Lighting & Feature Ceilings",
              "Turnkey Furnishing & Hotel-Grade Linen",
              "Kitchen Appliance Integration & Cutlery Setup",
              "Dubai Municipality & DTCM Permit Approvals"
            ],
            materials: ["Natural Oak Timber", "Brushed Brass", "Italian Porcelain", "Bouclé Textiles"],
            rooms: [
              {
                title: "Living & Promenade Lounge",
                desc: "Open plan seating layout featuring bespoke TV joinery, recessed indirect lighting, and neutral linen upholstery designed for sea views.",
                image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1600&q=85"
              },
              {
                title: "Master Sanctuary Bedroom",
                desc: "Upholstered king headboard wall with integrated reading sconces, sheer drapery, and high-thread-count hotel linens.",
                image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1600&q=85"
              },
              {
                title: "Gourmet Dining & Kitchen",
                desc: "Integrated breakfast bar, matte quartz countertops, and a fully equipped culinary inventory ready for immediate guest check-in.",
                image: "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
          {
            id: "serene-living-jbr-residences",
            slug: "serene-living-jbr-residences",
            bhk: "2 BHK",
            title: "Serene Living · JBR Residences",
            subtitle: "Warm Minimalist Coastal Apartment",
            description:
              "A calm, minimal palette pairs with timber joinery and integrated lighting. Styled for short-stay families and executive rentals with custom built-ins and organic textures.",
            image:
              "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "1,380 sq ft",
            turnkeyTimeline: "14 Days",
            completionYear: "2025",
            clientType: "Private Property Owner",
            gallery: [
              "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Custom Wall Paneling & Paint Refinement",
              "Bespoke Dining Nook & Floating Media Console",
              "Full Kitchen & Bathroom Accessories",
              "Smart Lock Self Check-in Setup"
            ],
            materials: ["Warm Walnut", "Travertine Stone", "Matte Black Metal"],
            rooms: [
              {
                title: "Primary Suite",
                desc: "Neutral tones, custom wall paneling, and blackout window treatments.",
                image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1600&q=85"
              },
              {
                title: "Lounge Nook",
                desc: "Custom floating shelves and warm ambient lighting for relaxed evenings.",
                image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
          {
            id: "serene-living-11-jbr",
            slug: "serene-living-11-jbr",
            bhk: "2 BHK",
            title: "Serene Living 11 · JBR",
            subtitle: "Modern Urban Beachfront Flat",
            description:
              "Soft neutrals, layered lighting, and a fully equipped kitchen. Configured for short-stay guests with premium linens, smart entry, and complete inventory.",
            image:
              "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "1,400 sq ft",
            turnkeyTimeline: "15 Days",
            completionYear: "2025",
            clientType: "Portfolio Manager",
            gallery: [
              "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Gypsum Ceilings & Magnetic Track Lighting",
              "Complete Soft Furnishings & Art Procurement",
              "Turnkey Kitchenware & Guest Amenities"
            ],
            materials: ["Linen", "Light Ash Wood", "Polished Chrome"],
            rooms: [
              {
                title: "Living Room",
                desc: "Spacious sofa layout with architectural coffee table and minimalist art pieces.",
                image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
          {
            id: "serene-living-18-jbr-penthouse",
            slug: "serene-living-18-jbr-penthouse",
            bhk: "4 BHK",
            title: "Serene Living 18 · JBR Penthouse",
            subtitle: "Luxury Penthouse Residence",
            description:
              "A spacious four-bedroom penthouse designed for high-end group travel — featuring multi-zone entertaining lounges, a chef's kitchen, and customized bedroom suites.",
            image:
              "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "3,800 sq ft",
            turnkeyTimeline: "24 Days",
            completionYear: "2025",
            clientType: "Ultra-High Net Worth Client",
            gallery: [
              "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Complete Penthouse Refurbishment & Civil Works",
              "Custom Marble Island & Italian Kitchen Fittings",
              "Bespoke Wardrobe Suites & Master Vanity",
              "Full Smart Home Automation & Sound System"
            ],
            materials: ["Calacatta Marble", "Smoked Glass", "Brushed Champagne Gold"],
            rooms: [
              {
                title: "Sky Lounge & Terrace",
                desc: "Panoramic sea views framed by floored glass and low-profile outdoor lounge seating.",
                image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
        ],
      },
      {
        area: "Dubai Marina",
        coords: "Marina Promenade",
        items: [
          {
            id: "horizon-2302-marina-skyline",
            slug: "horizon-2302-marina-skyline",
            bhk: "5 BHK",
            title: "Horizon 2302 · Marina Skyline",
            subtitle: "Five-Bedroom Statement Residence",
            description:
              "A five-bedroom statement penthouse with floor-to-ceiling marina views, layered ambient lighting, and gallery-style luxury finishes styled for high-end families.",
            image:
              "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "4,500 sq ft",
            turnkeyTimeline: "28 Days",
            completionYear: "2025",
            clientType: "Luxury Operator",
            gallery: [
              "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Complete 5-Bedroom Layout Fit-Out",
              "Custom Media Wall & Fireplace Feature",
              "Hotel-Grade Bedding & Executive Suites",
              "Authority Approvals & Civil Modifications"
            ],
            materials: ["Nero Marquina Marble", "Fluted Wood Paneling", "Custom Velvet"],
            rooms: [
              {
                title: "Great Room & Marina Gallery",
                desc: "High volume living space overlooking the yacht basin with custom fluted wall details.",
                image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
        ],
      },
      {
        area: "Downtown Dubai",
        coords: "Burj Khalifa District",
        items: [
          {
            id: "downtown-residence-3bhk",
            slug: "downtown-residence-3bhk",
            bhk: "3 BHK",
            title: "Downtown Residence · 3 BHK",
            subtitle: "Burj Khalifa View Executive Flat",
            description:
              "A three-bedroom Downtown apartment finished with a warm, contemporary palette. Walking distance to Dubai Mall and Burj Khalifa, configured for families and corporate stays.",
            image:
              "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "1,950 sq ft",
            turnkeyTimeline: "18 Days",
            completionYear: "2025",
            clientType: "Corporate Rental Investor",
            gallery: [
              "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Living Room Feature Wall & Gypsum Ceilings",
              "Complete Italian Dining & Lounge Setups",
              "Turnkey Kitchenware & Cutlery Packs"
            ],
            materials: ["Warm Beige Lime Wash", "Bronze Metal", "Oak Hardwood"],
            rooms: [
              {
                title: "Downtown Skyline Lounge",
                desc: "Floor-to-ceiling drapery framing the city skyline with minimalist lounge furniture.",
                image: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
          {
            id: "downtown-studio-suite",
            slug: "downtown-studio-suite",
            bhk: "1 BHK",
            title: "Downtown Studio Suite",
            subtitle: "Bespoke Compact Suite",
            description:
              "A compact one-bedroom near the Burj — fully styled with custom media wall, workspace, and premium mattress setup.",
            image:
              "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "780 sq ft",
            turnkeyTimeline: "10 Days",
            completionYear: "2025",
            clientType: "Individual Investor",
            gallery: [
              "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Custom Multi-functional Furniture Joinery",
              "Recessed LED Strip Details & Accent Lighting"
            ],
            materials: ["Matte Grey Oak", "Satin Brass"],
            rooms: [
              {
                title: "Studio Suite",
                desc: "Smart space planning integrating living, sleeping, and work zones seamlessly.",
                image: "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
        ],
      },
      {
        area: "Business Bay",
        coords: "Canal District",
        items: [
          {
            id: "business-bay-canal-residence",
            slug: "business-bay-canal-residence",
            bhk: "1 BHK",
            title: "Business Bay Canal Residence",
            subtitle: "Canal View Executive Residence",
            description:
              "A modern one-bedroom in Business Bay with canal views, a refined neutral palette, and a workspace-ready living area for executive travelers.",
            image:
              "https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "850 sq ft",
            turnkeyTimeline: "12 Days",
            completionYear: "2025",
            clientType: "Private Landlord",
            gallery: [
              "https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Living Room Refurbishment & Lighting Setup",
              "Complete Soft Furnishing Package"
            ],
            materials: ["Ash Grey Veneer", "Woven Textiles"],
            rooms: [
              {
                title: "Canal Lounge",
                desc: "Relaxed canal-side living space with ergonomic workspace desk.",
                image: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
          {
            id: "serene-living-44-business-bay",
            slug: "serene-living-44-business-bay",
            bhk: "1 BHK",
            title: "Serene Living 44 · Business Bay",
            subtitle: "Contemporary Minimalist Suite",
            description:
              "Styled with bespoke joinery, soft indirect lighting, and a calm material palette — engineered for high yield and top guest reviews.",
            image:
              "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "920 sq ft",
            turnkeyTimeline: "14 Days",
            completionYear: "2025",
            clientType: "Holiday Home Operator",
            gallery: [
              "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Feature Ceiling & Warm LED Tracks",
              "Turnkey Furnishings & Smart Home Lock Integration"
            ],
            materials: ["Warm Timber", "Brushed Gold", "Neutral Weaves"],
            rooms: [
              {
                title: "Living Nook",
                desc: "Integrated media wall with ambient backing lights.",
                image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
        ],
      },
    ],
  },
  {
    city: "Sharjah",
    areas: [
      {
        area: "Al Jada",
        coords: "Al Jada Master Community",
        items: [
          {
            id: "al-jada-residence-01",
            slug: "al-jada-residence-01",
            bhk: "1 BHK",
            title: "Al Jada Residence · 01",
            subtitle: "Master Community Modern Flat",
            description:
              "A modern one-bedroom inside Sharjah's Al Jada master community — clean lines, premium mattresses, and turnkey furnishing for short-stay guests.",
            image:
              "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "760 sq ft",
            turnkeyTimeline: "12 Days",
            completionYear: "2025",
            clientType: "Al Jada Property Owner",
            gallery: [
              "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1540518614846-7eded433c457?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Full Apartment Interior Styling",
              "Turnkey Kitchenware & Hotel Linens",
              "Smart Lock Check-in Setup"
            ],
            materials: ["Light Birch Wood", "Matte White", "Soft Grey Linen"],
            rooms: [
              {
                title: "Modern Lounge",
                desc: "Bright open seating area with Scandinavian minimalist furniture.",
                image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
          {
            id: "al-jada-residence-02",
            slug: "al-jada-residence-02",
            bhk: "1 BHK",
            title: "Al Jada Residence · 02",
            subtitle: "Warm Minimalist Sharjah Suite",
            description:
              "Warm minimalist styling, fully integrated kitchen, and curated artwork. Designed for couples and business travelers in central Sharjah.",
            image:
              "https://images.unsplash.com/photo-1540518614846-7eded433c457?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1540518614846-7eded433c457?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "780 sq ft",
            turnkeyTimeline: "13 Days",
            completionYear: "2025",
            clientType: "Private Investor",
            gallery: [
              "https://images.unsplash.com/photo-1540518614846-7eded433c457?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Custom Wall Decor & Paint",
              "Turnkey Inventory & Bedding"
            ],
            materials: ["Oak", "Cream Fabric"],
            rooms: [
              {
                title: "Bedroom Suite",
                desc: "Plush bed setup with textured acoustic headboard.",
                image: "https://images.unsplash.com/photo-1540518614846-7eded433c457?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
          {
            id: "al-jada-residence-03",
            slug: "al-jada-residence-03",
            bhk: "1 BHK",
            title: "Al Jada Residence · 03",
            subtitle: "Contemporary Brass Accent Suite",
            description:
              "Soft neutral palette with brass accents, a Smart TV media wall, and complete kitchen inventory — ready for immediate check-in.",
            image:
              "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "810 sq ft",
            turnkeyTimeline: "14 Days",
            completionYear: "2025",
            clientType: "Sharjah Holiday Home Operator",
            gallery: [
              "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Media Wall & Floating Furniture",
              "Full Inventory & Linen Pack"
            ],
            materials: ["Brushed Brass", "Warm Clay Wall Finish"],
            rooms: [
              {
                title: "Main Lounge",
                desc: "Warm clay walls with brushed brass accent lamps.",
                image: "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
          {
            id: "al-jada-residence-04",
            slug: "al-jada-residence-04",
            bhk: "1 BHK",
            title: "Al Jada Residence · 04",
            subtitle: "Executive Business Flat",
            description:
              "A bright one-bedroom with a contemporary lounge, dedicated workspace, and stylish bedroom — ideal for extended business stays.",
            image:
              "https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "800 sq ft",
            turnkeyTimeline: "13 Days",
            completionYear: "2025",
            clientType: "Private Owner",
            gallery: [
              "https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Workspace Fit-Out & Media Unit",
              "Complete Turnkey Living Furnishing"
            ],
            materials: ["Teak Wood", "Granite Countertop"],
            rooms: [
              {
                title: "Lounge & Workspace",
                desc: "Integrated desk nook and stylish sofa setup.",
                image: "https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
          {
            id: "al-jada-studio-suite",
            slug: "al-jada-studio-suite",
            bhk: "Studio",
            title: "Al Jada Studio Suite",
            subtitle: "Optimized Compact Studio",
            description:
              "A compact studio designed for solo travelers — every inch optimized with bespoke joinery, smart storage, and hotel-grade bedding.",
            image:
              "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=1600&q=85",
            beforeImage: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1600&q=85",
            afterImage: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=1600&q=85",
            areaSqft: "520 sq ft",
            turnkeyTimeline: "9 Days",
            completionYear: "2025",
            clientType: "Studio Investor",
            gallery: [
              "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=1600&q=85",
              "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1600&q=85"
            ],
            scope: [
              "Custom Murphy Bed & Storage Joinery",
              "Full Inventory Setup"
            ],
            materials: ["White Oak", "Brushed Aluminum"],
            rooms: [
              {
                title: "Studio Unit",
                desc: "Maximum utility studio layout with hidden storage.",
                image: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=1600&q=85"
              }
            ]
          },
        ],
      },
    ],
  },
];

// Flat list helper
export const ALL_PROJECTS = PROJECTS_GROUPS.flatMap((group) =>
  group.areas.flatMap((area) =>
    area.items.map((item) => ({
      ...item,
      city: group.city,
      area: area.area,
      coords: area.coords,
    }))
  )
);

// Lookup project by slug or ID
export function getProjectBySlug(slug) {
  return ALL_PROJECTS.find(
    (p) => p.slug === slug || p.id === slug || encodeURIComponent(p.title.toLowerCase()) === slug
  );
}
